<template>
    <v-container fluid fill-height>
        <v-card width="100%" flat :loading="isLoadingTenants">
            <v-card-text class="pa-0">
                <v-fab-transition>
                    <v-btn
                        :class="
                            $vuetify.breakpoint.smAndDown ? 'newTenantBtn' : ''
                        "
                        color="purple"
                        v-if="clicksToTenant >= 7"
                        @click="newTenant"
                        dark
                        fixed
                        bottom
                        right
                        fab
                        large
                    >
                        <v-icon size="25">mdi-plus</v-icon>
                    </v-btn>
                </v-fab-transition>
                <v-row>
                    <v-col
                        style="width: 100% !important"
                        class="d-flex flex-wrap flex-grow"
                        cols="12"
                        md="4"
                        v-for="tenant in availableTenants"
                        :key="tenant.id"
                    >
                        <TenantCard
                            style="width: 100% !important"
                            class=""
                            :tenant="tenant"
                        />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <newTenantForm/>
    </v-container>
</template>

<script>
import TenantCard from './TenantCard/TenantCard';
import newTenantForm from './newTenantForm.vue';
import { mapState } from 'vuex';

export default {
    name: 'TenantView',
    data: () => ({}),
    components: {
        TenantCard,
        newTenantForm
    },
    methods: {
        newTenant() {
            this.$store.commit('tenantManagement/defaultNewTenantForm');
            this.$store.state.tenantManagement.newTenant.formType = 'Create';
            this.$store.commit('tenantManagement/openNewTenantDialog', true);
        },
    },
    computed: {
        availableTenants() {
            return this.search
                ? this.tenants.filter((tenant) =>
                      tenant.name.includes(this.search.toString().toLowerCase())
                  )
                : this.tenants;
        },
        ...mapState('tenantManagement', {
            isLoadingTenants: (state) => state.isLoadingTenants,
            tenants: (state) => state.tenants,
        }),
        ...mapState('rrhh', {
            clicksToTenant: (state) => state.clicksToTenant,
        }),
        ...mapState('util', {
            search: (state) => state.navBarSearchField,
        }),
    },
};
</script>
<style scoped>
.newTenantBtn {
    position: fixed;
    bottom: 60px;
    z-index: 100;
    right: 20px;
}
</style>